module.exports = __webpack_public_path__ + "06_mole.e457acea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/06_mole.png
// module id = U7An
// module chunks = 0